<template>
  <component :is="currentComponent"></component>
</template>
<script>
import theApi from '@/mixins/theApi';
import store from '@/store/store';
//import router from "@/router/router";

export default {
  computed: {
    experience() {
      if (this.loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        const experience = experiences.find((i) => i.id == this.$route.params.id);
        return experience;
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    learningresource() {
      if (this.experience) {
        const learningresource = this.experience.learningresources;
        return learningresource;
      }
      return false;
    },
    componentInstance() {
      return () =>
        import(
          '@/views/WorkExperiences/' + this.experience.vje.folder_name + '/LearningResources.vue'
        );
    },
    isEditable() {
      if (this.experience && this.experience.active) return true;
      return false;
    },
    currentComponent: function () {
      return () =>
        import(
          '@/views/WorkExperiences/' + this.experience.vje.folder_name + '/LearningResources.vue'
        );
    },
  },
  data() {
    return {
      apiUrl:
        localStorage.getItem('login_type') === 'student'
          ? $vjeConfig.VUE_APP_API_URL + 'student/experiences/activities/get'
          : $vjeConfig.VUE_APP_API_URL + 'teacher/experiences/activities/get',
      data: {},
      uploaded_file: '',
      uploaded_files: null,
      loginType: localStorage.getItem('login_type'),
      disableSave: false,
      showSaveProgress: false,
      isModified: false,
      intervalid1: null,
    };
  },
  methods: {
    async saveLR(data, file, filetype) {
      const formData = new FormData();
      formData.append('student_vje_id', this.$route.params.id);
      formData.append('data', JSON.stringify(data));
      if (typeof file !== 'undefined') formData.append('file', file);
      else formData.append('file', -1);
      if (typeof filetype !== 'undefined') formData.append('filetype', filetype);

      this.disableSave = true;
      this.showSaveProgress = true;
      theApi.methods
        .makeCall(
          false,
          'experiences/lr/save',
          'post',
          formData,
          'Learning & Resources saved successfully!',
          true,
        )
        .then(
          (data) => {
            if (data.status == 'OK') {
              const lr_data = {
                student_vje_id: this.$route.params.id,
                data: JSON.stringify(this.data),
              };
              store.commit('authStudent/updateExperienceLR', lr_data);
              if (typeof data.file !== 'undefined') {
                this.uploaded_file = data.file;
              }
              this.isModified = false;
            }
            this.disableSave = false;
            this.showSaveProgress = false;
          },
          () => {
            this.disableSave = false;
            this.showSaveProgress = false;
          },
        );
    },
    async autosaveLR() {
      let data = this.data;
      const formData = new FormData();
      formData.append('student_vje_id', this.$route.params.id);
      formData.append('data', JSON.stringify(data));

      this.disableSave = true;
      this.showSaveProgress = true;
      theApi.methods
        .makeCall(
          false,
          'experiences/lr/save',
          'post',
          formData,
          'Learning & Resources autosaved successfully!',
          true,
        )
        .then(
          (data) => {
            if (data.status == 'OK') {
              const lr_data = {
                student_vje_id: this.$route.params.id,
                data: JSON.stringify(this.data),
              };
              store.commit('authStudent/updateExperienceLR', lr_data);
              this.isModified = false;
            }
            this.disableSave = false;
            this.showSaveProgress = false;
          },
          () => {
            this.disableSave = false;
            this.showSaveProgress = false;
          },
        );
    },
    getLRData() {
      const student_lr = this.experience.learningresources;
      if (student_lr) {
        const data = JSON.parse(student_lr.data);
        if (data) {
          this.data = data;
        } else {
          this.data = {};
        }
        this.uploaded_file = data.file;
        if (typeof data.multiple_files !== 'undefined') {
          this.uploaded_files = data.multiple_files;
        }
      } else {
        this.data = {};
        this.uploaded_file = '';
      }
    },
    getData() {
      return this.data;
    },
    setData(data) {
      this.data = data;
    },
    getUploadedFile() {
      return this.uploaded_file;
    },
    setUploadedFile(data) {
      this.uploaded_file = data;
    },
    getUploadedFiles() {
      return this.uploaded_files;
    },
    setUploadedFiles(data) {
      this.uploaded_files = data;
    },
    startFileUpload() {
      this.disableSave = true;
    },
    endFileUpload() {
      this.disableSave = false;
    },
    showIframePopup(url) {
      store.dispatch('popup/showIframePopup', url);
    },
    showVideoPopup(url) {
      if (url.includes('youtube.com')) store.dispatch('popup/showIframePopup', url);
      else store.dispatch('popup/showVideoPopup', url);
    },
    enableAutosave: function () {
      const self = this;

      this.intervalid1 = setInterval(function () {
        if (self.isModified) {
          self.autosaveLR();
        }
      }, 60000);
    },
  },
  watch: {
    data: {
      handler: function () {
        this.isModified = true;
      },
      deep: true,
    },
  },
  mounted() {
    this.getLRData();
    let vm = this;
    setTimeout(function () {
      vm.isModified = false;
      vm.enableAutosave();
    }, 500);
  },
  reactiveProvide: {
    name: 'saveConfig',
    include: ['disableSave', 'showSaveProgress'],
  },
  provide: function () {
    return {
      saveLR: this.saveLR,
      getLRData: this.getLRData,
      getData: this.getData,
      setData: this.setData,
      getUploadedFile: this.getUploadedFile,
      setUploadedFile: this.setUploadedFile,
      getUploadedFiles: this.getUploadedFiles,
      setUploadedFiles: this.setUploadedFiles,
      uploaded_file: this.uploaded_file,
      isEditable: this.isEditable,
      //isFileUploading: this.isFileUploading,
      startFileUpload: this.startFileUpload,
      endFileUpload: this.endFileUpload,
      showIframePopup: this.showIframePopup,
      showVideoPopup: this.showVideoPopup,
      closePopup: this.closePopup,
    };
  },
};
</script>
